<template>
	<nav class="nav">
		<router-link class="item" :to="{name: 'index'}">
			<div class="icon" v-html="require('@/assets/icons/home-solid.svg')"/>
			<div class="text">Forside</div>
		</router-link>
		<router-link class="item" :to="{name: 'library'}">
			<div class="icon" v-html="require('@/assets/icons/folder-open-solid.svg')"/>
			<div class="text">Bibliotek</div>
		</router-link>
		<router-link class="item" :to="{name: 'profile'}">
			<div class="icon" v-html="require('@/assets/icons/user-solid.svg')"/>
			<div class="text">Profil</div>
		</router-link>
		<router-link class="item" :to="{name: 'contact'}">
			<div class="icon" v-html="require('@/assets/icons/envelope-solid.svg')"/>
			<div class="text">Kontakt</div>
		</router-link>
		<a class="item" @click="logout">
			<div class="icon" v-html="require('@/assets/icons/arrow-alt-square-left.svg')"/>
			<div class="text">Log ud</div>
		</a>
	</nav>
</template>

<script>
export default {
	methods: {
		logout() {
			this.$store.dispatch("user/logout");
		}
	}
};
</script>
